import { supabase } from "@/integrations/supabase/client";

export interface OpenComandaInput {
  clinicId: string;
  reservationId: string;
  petId: string;
  ownerId: string | null;
  lines: Array<{ itemName: string; quantity: number; unitPrice: number; itemId?: string | null; stayDate?: string | null }>;
}

export interface OpenComandaResult {
  saleId: string;
  insertedLines: Array<{ id: string; stayDate: string | null }>;
}

/** Abre a comanda POS da estadia: cria uma venda ABERTA vinculada à reserva e insere as linhas avulsas. */
export function useOpenStayComanda() {
  return {
    openComanda: async ({ clinicId, reservationId, petId, ownerId, lines }: OpenComandaInput) => {
      const { data: sale, error } = await (supabase as any)
        .from("sales")
        .insert({
          sale_number: `V${Date.now()}`,
          clinic_id: clinicId,
          stay_reservation_id: reservationId,
          pet_id: petId,
          owner_id: ownerId,
          status: "ABERTA",
          subtotal: lines.reduce((sum, line) => sum + line.quantity * line.unitPrice, 0),
          total: lines.reduce((sum, line) => sum + line.quantity * line.unitPrice, 0),
        })
        .select("id")
        .single();
      if (error) throw error;
      if (lines.length) {
        const { data: insertedItems, error: itemError } = await (supabase as any).from("sale_items").insert(
          lines.map((line) => ({
            sale_id: sale.id,
            item_name: line.itemName,
            item_id: line.itemId ?? null,
            quantity: line.quantity,
            unit_price: line.unitPrice,
            line_total: line.quantity * line.unitPrice,
          })),
        ).select("id");
        if (itemError) throw itemError;
        return {
          saleId: sale.id,
          insertedLines: (insertedItems ?? []).map((item: { id: string }, index: number) => ({
            id: item.id,
            stayDate: lines[index]?.stayDate ?? null,
          })),
        };
      }
      return { saleId: sale.id, insertedLines: [] };
    },
  };
}
